<template>
  <b-row id="health-rest" class="section-invert reverse-sm">
        <b-col v-if="!$uiHelpers.isMobile" md="12" lg="6">
      <div class="col-bg ml-lg-auto"></div>
    </b-col>
    <b-col md="12" lg="6" class="content my-auto">
      <h3>{{ $t("healthappyrest.title") }}</h3>
      <div class="subtitle">
        <div class="subtitle-list subtitle-list mt-sm-5">
          <div>
            <p>
              <v-icon large>mdi-video-plus-outline</v-icon
              >{{ $t("healthappyrest.psico") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-cellphone-information'"></v-icon
              >{{ $t("healthappyrest.yoga") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon
                large
                v-text="'mdi-file-document-multiple-outline'"
              ></v-icon
              >{{ $t("healthappyrest.relax") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-comment-processing-outline'"></v-icon
              >{{ $t("healthappyrest.premium") }}
            </p>
          </div>
        </div>
      </div>
      <router-link to="/opensaludprime/mindfulness">
        <base-button style="color:white" class="btn-more-info-white" white outline><span style="color:white">{{ $t('buy-btn') }}</span></base-button>
      </router-link>
    </b-col>
     <b-col v-if="$uiHelpers.isMobile" md="12" lg="6">
      <div class="col-bg ml-lg-auto"></div>
    </b-col>
  </b-row>
</template>

<script>
/*   import 'material-design-icons-iconfont/dist/material-design-icons.css' */

  export default {
  }
</script>

<style lang="scss">
  @import "../../../static-appopensalud/css/public/layout.scss";

  #health-rest .col-bg {
    background-image: url(/static-appopensalud/img/bgs/opt/saludmental1.jpg),
      linear-gradient(273deg, #ffffff96, transparent);
    background-position: center;
    background-blend-mode: overlay;
  }
  @media (max-width: 1268px) {
    #health-rest
      > div.content.my-auto.col-md-12.col-lg-6
      > div
      > div
      > div
      > p {
      font-size: 1rem;
    }
  }
  .btn-more-info-white {
    span {
        color: white !important;font-weight:bold; border-color:white;font-size:0.8rem;
      }
  }
   .btn-more-info-white:hover{
    color: #eee;
    background-color: #3238C4;
    border-color: #3238C4;
    span {
      color: #1D1D1E !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/HealthHappinessAndRest.vue